import React, { SVGProps } from 'react'
const SvgAiAgentActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <g id="iconLeft">
      <path
        id="Vector"
        d="M4.11341 7.98656L7.37279 3.56322C7.69682 3.12347 8.38432 3.35672 8.38432 3.90641V6.65193C8.38432 6.96783 8.63592 7.22392 8.94629 7.22392H11.4371C11.8896 7.22392 12.1565 7.74043 11.9002 8.11995L8.99726 12.4176C8.68461 12.8805 7.97222 12.6553 7.97222 12.0936V9.47372C7.97222 9.15782 7.72062 8.90174 7.41026 8.90174H4.56298C4.0999 8.90174 3.83556 8.36363 4.11341 7.98656Z"
        fill={props.fill || 'var(--color-cta)'}
      />
    </g>
  </svg>
)
export default SvgAiAgentActive
